import React, { useEffect, useState } from "react";
import classes from "./MainPageFooter.module.css";
import { ReactComponent as PostmanLogo } from "../assets/postmanFooter.svg";
import { ReactComponent as Facebook } from "../assets/facebookFooter.svg";
import { ReactComponent as LinkedIn } from "../assets/linkedinFooter.svg";
import { ReactComponent as Instagram } from "../assets/instagramFooter.svg";
import { ReactComponent as X } from "../assets/xFooter.svg";
import AppStore from "../assets/appStore.png";
import GooglePlay from "../assets/downloadGooglePlay.png";
import { Image } from "antd";
import { getConfigurationValue } from "../lib/OptionListApi";
import { ReactComponent as EuroKargo } from "../assets/LOGOA.svg";

interface MainPageFooterProps {
	country?: number | undefined;
}

const MainPageFooter: React.FC<MainPageFooterProps> = ({ country }) => {
	const kosovoData = {
		company: "Postman SH.P.K. NRB:811423053",
		address: [
			"rr. Ismet Krasniqi, p.n, Zona Industriale",
			"10000 Prishtinë, Republika e Kosovës",
		],
		contacts: ["038 616 626", "+383-49285007", "+383-46285007"],
	};

	const albaniaData = {
		company: "Postman SH.P.K. NIPT:M21325006O",
		address: [
			"Rr. Fshati Picar, Rrugadytesore Tirane-Durres Km 12 ",
			// eslint-disable-next-line quotes
			'Kompleksi "Prestige Industrial Park" Magazina B07',
			"Republika e Shqipërise",
		],
		contacts: ["+355 69 703 7712", "+355 69 704 6358"],
	};
	const macedonianData = {
		company: [
			"Podruznica Euro KARGO",
			"Embs ( nr i firems )7273100/3",
			"Edb ( numri tatimor) 402 801 853 4688",
		],
		address: [
			"Ulica (rruga)181 br 26 Tetovo",
			// eslint-disable-next-line quotes
			"Republika e Maqedonise",
		],
		contacts: ["078-465-465", "eurokargo21@gmail.com"],
	};

	const [configurationId, setConfigurationId] = useState<number | undefined>(
		undefined
	);

	const fetchConfiguration = async () => {
		const countryConfigurationValue = await getConfigurationValue(2);
		const countryValue = Number(countryConfigurationValue);
		setConfigurationId(countryValue);
	};

	useEffect(() => {
		fetchConfiguration();
	}, []);

	return (
		<div className={classes.mainComponent}>
			<div className={classes.firstContainer}>
				{configurationId === 3 ? (
					<EuroKargo className="secondPostmanLogo" />
				) : (
					<PostmanLogo className="secondPostmanLogo" />
				)}
				<div className={classes.mainInfos}>
					<div className={classes.infos}>
						<p>
							{country && country === 1
								? kosovoData.company
								: country === 2
								? albaniaData.company
								: country === 3
								? macedonianData.company.map((line, index) => (
										<span key={index}>
											{line}
											<br />
										</span>
								  ))
								: null}
						</p>
						<p>
							{country && country === 1
								? kosovoData.address.map((line, index) => (
										<span key={index}>
											{line}
											<br />
										</span>
								  ))
								: country === 2
								? albaniaData.address.map((line, index) => (
										<span key={index}>
											{line}
											<br />
										</span>
								  ))
								: country === 3
								? macedonianData.address.map((line, index) => (
										<span key={index}>
											{line}
											<br />
										</span>
								  ))
								: null}
						</p>
					</div>
					<div className={classes.contacts}>
						<p>Telefonat për kontakt:</p>
						{country && country === 1
							? kosovoData.contacts.map((contact, index) => (
									<p
										key={index}
										className={classes.textRight}
									>
										{contact}
									</p>
							  ))
							: country === 2
							? albaniaData.contacts.map((contact, index) => (
									<p
										key={index}
										className={classes.textRight}
									>
										{contact}
									</p>
							  ))
							: country === 3
							? macedonianData.contacts.map((contact, index) => (
									<p
										key={index}
										className={classes.textRight}
									>
										{contact}
									</p>
							  ))
							: null}
					</div>
				</div>
				<div className={classes.lastFooter}>
					<div className={classes.icons}>
						<Image src={AppStore} preview={false} />
						<Image src={GooglePlay} preview={false} />
					</div>
					<div className={classes.socials}>
						<Facebook />
						<LinkedIn />
						<Instagram />
						<X />
					</div>
				</div>
			</div>
		</div>
	);
};

export default MainPageFooter;
